import { render, staticRenderFns } from "./arrearsRateReport.vue?vue&type=template&id=037fafc8&scoped=true"
import script from "./arrearsRateReport.vue?vue&type=script&lang=js"
export * from "./arrearsRateReport.vue?vue&type=script&lang=js"
import style0 from "./arrearsRateReport.vue?vue&type=style&index=0&id=037fafc8&prod&scoped=true&lang=css"
import style1 from "./arrearsRateReport.vue?vue&type=style&index=1&id=037fafc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037fafc8",
  null
  
)

export default component.exports